/**
 * Базовый класс для типов элементов из FULL_ELEMENT_MAP (с иконкой, слоем, аспектом).
 * Наследники задают только typeName; данные берутся из мапы.
 */
import ArchimateNodeType from './ArchimateNodeType';
import {FULL_ELEMENT_MAP} from '../util/ModelUtil';
import {COLOR_LAYER_MAP, toRgbaString} from '../draw/ArchimateRendererUtil';
import {COLOR_LOCATION} from '../util/ColorUtil';
import * as CX from '../metamodel/Concept';
const LAYER_OTHER = CX.LAYER_OTHER;

const DEFAULT_SIZE = {width: 120, height: 55};

export default class ElementNodeTypeBase extends ArchimateNodeType {
	static get typeName() {
		return 'Element';
	}

	/** Запись из FULL_ELEMENT_MAP для данного типа */
	get entry() {
		return FULL_ELEMENT_MAP.get(this.constructor.typeName) || null;
	}

	get defaultSize() {
		return DEFAULT_SIZE;
	}

	/** Ссылка на иконку (pictoRef / pathMap / figureRef) */
	get iconRef() {
		const e = this.entry;
		return (e && (e.pictoRef || e.pathMap || e.figureRef)) || null;
	}

	get layer() {
		return (this.entry && this.entry.layer) || null;
	}

	get aspect() {
		return (this.entry && this.entry.aspect) || null;
	}

	/** Цвет заливки по слою (если не передан customFill). Location — как в diagram-js (COLOR_LOCATION). */
	getDefaultFillColor(customFill) {
		if (customFill) return customFill;
		if (this.constructor.typeName === CX.OTHER_LOCATION) return COLOR_LOCATION;
		const layer = this.layer;
		const color =
			COLOR_LAYER_MAP.get(layer) ||
			(layer === LAYER_OTHER ? {r: '255', g: '255', b: '255', a: '100'} : null);
		return color ? toRgbaString(color) : '#ffffff';
	}

	/** Цвет обводки по умолчанию */
	getDefaultLineColor(customLine) {
		return customLine || '#000000';
	}
}
